<template>
  <b-row v-if="$route.name === 'EXSBRefundCreate'">
    <b-col>
      <router-link :to="{ name: 'EXSBRefundList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
    </b-col>
    <b-col cols="12">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col>
              <Form
                :handle-submit="onSendForm"
                :values="item"/>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-col>
  </b-row>
  <div v-else>
    <b-col>
      <Form
        :handle-submit="onSendForm"
        :values="item"/>
    </b-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'
import moment from 'moment'

export default {
  name: 'Create',
  components: {
    Form
  },
  props: ['idBankPayment'],
  data () {
    return {
      item: {
        idClient: null,
        idBankPayment: '',
        value: '0.00',
        description: '',
        paymentDate: moment().format('YYYY-MM-DD')
      }
    }
  },
  watch: {
    created (val) {
      if (val) {
        if (this.$route.name !== 'EXSBRefundCreate') {
          return
        }
        this.$router.push({ name: 'EXSBRefundList' })
      }
    }
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBRefundCreate')
  },
  created () {
    if (this.idBankPayment) {
      this.item.idBankPayment = this.idBankPayment
    }
  },
  computed: {
    ...mapGetters({
      created: 'exsbrefund/create/created',
      isLoading: 'exsbrefund/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'exsbrefund/create/create'
    })
  }
}
</script>

<style scoped>

</style>
